


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const ToClerkAfterApproval = () => {
    const [selectedAction, setSelectedAction] = useState("All");
     const language = useSelector((state:any)=>state.auth.language);

    const statusOptions = [
        {value: "all" , label:"All"},
        { value: "pendingAtClerk", label: "Pending At Clerk" },
        { value: "pendingAtCo", label: "Pending At Co" },
        { value: "pendingAtClerkResubmission", label: "Pending At Clerk Resubmission" },
        { value: "pendingAtCoResubmission", label: "Pending At Co Resubmission" },
        { value: "pendingAtDr", label: "Pending At Dr" },
        { value: "pendingAtDrResubmission", label: "Pending At Dr Resubmission" },
        
      ];

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable status={statusOptions} />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default ToClerkAfterApproval;
